// extracted by mini-css-extract-plugin
export default {"container":"tL-z","error":"uL-z","disabled":"vL-z","submit":"wL-z","option":"xL-z","success":"yL-z","failure":"zL-z"};